import { Button } from '@/components/ui/button';
import { Minus, Plus } from 'lucide-react';

interface QuantitySelectorProps {
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
  className?: string;
}

export function QuantitySelector({
  value,
  onChange,
  min = 1,
  max,
  className = '',
}: QuantitySelectorProps) {
  const handleDecrease = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  const handleIncrease = () => {
    if (!max || value < max) {
      onChange(value + 1);
    }
  };

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={handleDecrease}
        disabled={value <= min}
        className="h-8 w-8 p-0 rounded-full border-slate-200"
      >
        <Minus className="h-4 w-4" />
      </Button>

      <div className="flex items-center justify-center min-w-[3rem]">
        <span className="text-lg font-semibold text-slate-900">{value}</span>
      </div>

      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={handleIncrease}
        disabled={max ? value >= max : false}
        className="h-8 w-8 p-0 rounded-full border-slate-200"
      >
        <Plus className="h-4 w-4" />
      </Button>
    </div>
  );
}
